/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './dropdown.component.scss.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../app/shared/dropdown/dropdown.component';
import * as i3 from '../../../../app/shared/browser-events.service';
import * as i4 from '../../../../app/shared/dropdown/dropdown.service';
const styles_DropdownComponent:any[] = [i0.styles];
export const RenderType_DropdownComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:2,
    styles:styles_DropdownComponent,data:{}});
export function View_DropdownComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵncd((null as any),0)],(null as any),(null as any));
}
export function View_DropdownComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'dropdown',([] as any[]),
      [[2,'disabled',(null as any)]],(null as any),(null as any),View_DropdownComponent_0,
      RenderType_DropdownComponent)),i1.ɵdid(1228800,(null as any),5,i2.DropdownComponent,
      [i1.ElementRef,i1.Renderer2,i3.BrowserEvents,i4.DropdownService],(null as any),
      (null as any)),i1.ɵqud(335544320,1,{trigger:0}),i1.ɵqud(335544320,2,{menu:0}),
      i1.ɵqud(335544320,3,{origin:0}),i1.ɵqud(603979776,4,{menuItems:1}),i1.ɵqud(335544320,
          5,{input:0})],(null as any),(_ck,_v) => {
    const currVal_0:any = i1.ɵnov(_v,1).disabled;
    _ck(_v,0,0,currVal_0);
  });
}
export const DropdownComponentNgFactory:i1.ComponentFactory<i2.DropdownComponent> = i1.ɵccf('dropdown',
    i2.DropdownComponent,View_DropdownComponent_Host_0,{trigger:'trigger',origin:'origin',
        direction:'direction',autoPosition:'autoPosition',disabled:'disabled'},{onFirstOpen:'onFirstOpen',
        onClose:'onClose'},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2Ryb3Bkb3duL2Ryb3Bkb3duLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9kcm9wZG93bi9kcm9wZG93bi5jb21wb25lbnQudHMiLCJuZzovLy9tbnQvZS9hcHBzL2hlbHBkZXNrL2NsaWVudC9zcmMvYXBwL3NoYXJlZC9kcm9wZG93bi9kcm9wZG93bi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL21udC9lL2FwcHMvaGVscGRlc2svY2xpZW50L3NyYy9hcHAvc2hhcmVkL2Ryb3Bkb3duL2Ryb3Bkb3duLmNvbXBvbmVudC50cy5Ecm9wZG93bkNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxuZy1jb250ZW50PjwvbmctY29udGVudD4iLCI8ZHJvcGRvd24+PC9kcm9wZG93bj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OzsyQkNBQTs7O29CQ0FBO01BQUE7a0NBQUEsVUFBQTtNQUFBO01BQUE7YUFBQTtVQUFBO0lBQUE7SUFBQSxXQUFBLFNBQUE7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/e/apps/helpdesk/client/src/$$_gendir/app/shared/dropdown/dropdown.component.ngfactory.ts